import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { t as i18nextT } from 'i18next';
import * as S from './EditProfileSection.styles';
import { Input } from '@/components/UI/Input/Input';
import { USER_NAME_MAX_LENGTH } from '@/constants/common';

export const editProfileFormSchema = z.object({
  name: z.string(),
  email: z.string().email(i18nextT('common.invalid_address_entered')),
});

export type EditProfileFormFields = z.infer<typeof editProfileFormSchema>;

export const EditProfileSection = () => {
  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<EditProfileFormFields>({
    resolver: zodResolver(editProfileFormSchema),
    defaultValues: {
      name: '',
      email: '',
    },
  });

  function onSubmit(data: EditProfileFormFields) {
    console.log('submit', data);
  }

  return (
    <>
      <S.Form onSubmit={handleSubmit(onSubmit)} noValidate>
        <S.Inputs>
          <Controller
            name="name"
            control={control}
            render={({ field, fieldState }) => (
              <Input
                {...field}
                maxLength={USER_NAME_MAX_LENGTH}
                label={t('common.name')}
                helperText={fieldState.error?.message}
                hasError={!!fieldState.error}
              />
            )}
          />

          <Controller
            name="email"
            control={control}
            render={({ field, fieldState }) => (
              <Input
                {...field}
                label="E-mail"
                type="email"
                helperText={fieldState.error?.message}
                hasError={!!fieldState.error}
              />
            )}
          />
        </S.Inputs>

        <S.SubmitButton appearance="primary" isFullWidth type="submit">
          {t('common.save')}
        </S.SubmitButton>
      </S.Form>

      <S.ProfileNumber $variant="3">
        {t('pages.cabinet.profile_number_colon')} 21486102
      </S.ProfileNumber>
    </>
  );
};
